<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: {
      handler(to) {
        document.title = to.meta.title || "Climb - Administração";
      },
      immediate: true
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap");

* {
  margin: 0;
  padding: 0;
  border: none;
  font-family: "Open Sans", sans-serif;
}
</style>
